import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import "./globals.css";

import { AppLayout } from "@/components/AppLayout";
import { AdminRoute } from "@/components/AdminRoute";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { BillingGate } from "@/components/BillingGate";
import { Abbonamento } from "@/pages/Abbonamento";
import { AuthProvider } from "@/lib/AuthProvider";
import { OperatoreProvider } from "@/lib/operatoreContext";
import { AuthCallback } from "@/pages/AuthCallback";
import { AuthExit } from "@/pages/AuthExit";
import { Login } from "@/pages/Login";
import { AdminUsers } from "@/pages/AdminUsers";
import { Dashboard } from "@/pages/Dashboard";
import { Anagrafiche } from "@/pages/Anagrafiche";
import { Codifiche } from "@/pages/Codifiche";
import { Registri } from "@/pages/Registri";
import { Formulari } from "@/pages/Formulari";
import { Vidimazione } from "@/pages/Vidimazione";
import { Contacts } from "@/pages/Contacts";
import { Drafts } from "@/pages/Drafts";
import { JobsPage } from "@/pages/Jobs";
import { AuditPage } from "@/pages/Audit";
import { Impostazioni } from "@/pages/Impostazioni";
import { Analytics } from "@/pages/Analytics";
import { Giacenze } from "@/pages/Giacenze";
import { CerAttivi } from "@/pages/CerAttivi";
import { AutistaPage } from "@/pages/Autista";
import { GestoreAziende } from "@/pages/GestoreAziende";

const qc = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: 1 },
  },
});

if ("serviceWorker" in navigator && import.meta.env.PROD) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => undefined);
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <AuthProvider>
      <OperatoreProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/auth/exit" element={<AuthExit />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          {/* Modalità autista (fullscreen mobile, no sidebar) */}
          <Route
            path="/autista"
            element={
              <ProtectedRoute>
                <AutistaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/autista/:firNumero"
            element={
              <ProtectedRoute>
                <AutistaPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/abbonamento"
            element={
              <ProtectedRoute>
                <Abbonamento />
              </ProtectedRoute>
            }
          />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <BillingGate />
              </ProtectedRoute>
            }
          >
            <Route element={<AppLayout />}>
            <Route index element={<Dashboard />} />
            <Route path="anagrafiche" element={<Anagrafiche />} />
            <Route path="codifiche" element={<Codifiche />} />
            <Route path="registri" element={<Registri />} />
            <Route path="formulari" element={<Formulari />} />
            <Route path="vidimazione" element={<Vidimazione />} />
            <Route path="contacts" element={<Contacts />} />
            <Route path="cer-attivi" element={<CerAttivi />} />
            <Route path="drafts" element={<Drafts />} />
            <Route path="drafts/:id" element={<Drafts />} />
            <Route path="jobs" element={<JobsPage />} />
            <Route path="audit" element={<AuditPage />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="giacenze" element={<Giacenze />} />
            <Route path="impostazioni" element={<Impostazioni />} />
            <Route path="gestore" element={<GestoreAziende />} />
            <Route
              path="admin"
              element={
                <AdminRoute>
                  <AdminUsers />
                </AdminRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </OperatoreProvider>
      </AuthProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
